import "@/plugins/bridge.js";
import { wxshareInit } from "@/plugins/wechatSDK.js";

export default function useShare() {
  let shareUrl = "https://zsrbactivity.zsnews.cn/vue/week_vote/#/";
  let shareTitle = "投票丨《美周》影像作品投票开始啦";
  let shareDesc = "赶快动动手指支持吧";
  const userAgentString = navigator.userAgent.toLowerCase();
  if (userAgentString.indexOf("zsrbapp") >= 0) {
    window.ZsrbApp.call("shareInfo", {
      title: shareTitle,
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      desc: shareDesc,
      url: shareUrl,
    });
  } else if (userAgentString.indexOf("micromessenger") >= 0) {
    wxshareInit({
      title: shareTitle,
      imgUrl:
        "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      description: shareDesc,
      url: shareUrl,
      successMethod: "",
    });
  }
}
